import React, { useEffect, useState } from 'react'
import { observer } from "mobx-react-lite"
import { useNavigate } from '@reach/router';

import Button from '@mui/material/Button';
import classes from './ShareCard.module.scss'
import clsx from 'clsx';


const ShareCardCol = observer(({title, desc, img}) => {
  return <div className={classes.shareIconCol}>
    <div className={clsx(classes.shareIconColImg, img)}></div>
    <div className={classes.shareIconColTitle}>{title}</div>
    <div className={classes.shareIconColDesc}>{desc}</div>
  </div>
})

const ShareCard = observer(({className, description}) => {
  const navigate = useNavigate();

  return <div className={clsx(className, classes.shareCard)}>
    <div className={classes.shareTitle}>Make custom loops today</div>
    {description}
    <div className={classes.shareIcons}>
      <ShareCardCol title="Customized Loops" desc="Build customized loops based on grooves, chord changes, FX, and more in seconds." img={classes['img1']} />
      <ShareCardCol title="Royalty free" desc="All samples downloaded are royalty free and you can keep them forever."  img={classes['img2']} />
      <ShareCardCol title="Cancel at any time" desc="You can cancel your plan at any time. A 14-day free trial is provided before you purchase."  img={classes['img3']} />
    </div>
    <div className={classes.shareActions}>
      <Button className={classes.shareStarted} variant='contained' disableElevation onClick={() => navigate('/auth/signup')}>START FOR FREE</Button>
    </div>
  </div>
})

export default ShareCard